// Web 应用认证适配器
// 注意：getCurrentUser 已迁移到 userService.ts，这里保留是为了向后兼容
// 新代码应该使用 userService.getCurrentUser()
import { supabase } from '@ext-bookmark/shared/api';
import { getCurrentUser as getUserFromService } from './userService';
import type { User } from '@supabase/supabase-js';

/**
 * 获取当前用户（已迁移到 userService，这里保留向后兼容）
 * @deprecated 请使用 userService.getCurrentUser() 代替
 */
export async function getCurrentUser(): Promise<User | null> {
  return getUserFromService();
}

/**
 * 更新用户名
 * @param username 新用户名
 * @param userId 可选的用户ID，如果提供则不需要再次获取用户
 */
export async function updateUsername(username: string, userId?: string): Promise<{ success: boolean; error?: string }> {
  if (!supabase) {
    return { success: false, error: 'Supabase 未配置' };
  }

  // 如果提供了 userId，直接使用，避免重复请求
  let currentUserId = userId;
  if (!currentUserId) {
    // 使用 userService 获取用户（会从 React Query 缓存获取）
    const user = await getUserFromService();
    if (!user) {
      return { success: false, error: '用户未登录' };
    }
    currentUserId = user.id;
  }

  // 验证用户名
  const trimmed = username.trim();
  if (!trimmed) {
    return { success: false, error: '用户名不能为空' };
  }

  // 用户名长度限制（支持 emoji，所以使用字符数而不是字节数）
  if (trimmed.length > 50) {
    return { success: false, error: '用户名不能超过 50 个字符' };
  }

  try {
    const { error } = await supabase
      .from('profiles')
      .update({
        username: trimmed,
        updated_at: new Date().toISOString(),
      })
      .eq('id', currentUserId);

    if (error) {
      console.error('[AuthAdapter] 更新用户名失败:', error);
      return { success: false, error: error.message || '更新用户名失败' };
    }

    return { success: true };
  } catch (error: any) {
    console.error('[AuthAdapter] 更新用户名异常:', error);
    return { success: false, error: error.message || '更新用户名时发生未知错误' };
  }
}
